export interface IAdminUser {
  administrator_code?: string;
  administrator_name?: string;
  login_id?: string;
  login_password?: string;
}

export class AdminUserDTO implements IAdminUser {
  public administrator_code?: string;
  public administrator_name?: string;
  public login_id?: string;
  public login_password?: string;
}

export default class AdminUser extends AdminUserDTO {
  public original = {};
  constructor(dto?: AdminUserDTO) {
    super();
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }
  public new() {
    Object.assign(this, {
      administrator_code: "",
      administrator_name: "",
    });
  }
}
